import type { ExamFormTestProm, Question } from "@rmh/defs";
import { Prom, TestKey } from "@rmh/defs";
import { defaults, PROM_TEST_TITLE_PREFIX } from "./defaults";
import { neckDisabilityIndexEn } from "./en/neckDisabilityIndex";
import { neckDisabilityIndexEs } from "./es/neckDisabilityIndex";

const createProm = (locale: string): ExamFormTestProm => {
  const translations =
    locale === "es" ? neckDisabilityIndexEs : neckDisabilityIndexEn;

  return {
    promName: "Neck Disability Index (NDI)",
    promBodyRegion: Prom.NeckDisabilityIndex,
    redToGreen: false,
    startAt: 0,
    updatedAt: new Date().toISOString(),
    testKey: TestKey.NeckDisabilityIndex,
    testTitle: `${PROM_TEST_TITLE_PREFIX} - Neck Disability Index (NDI)`,
    questions: translations.questions,
  };
};

export const neckDisabilityIndexProm = {
  ...defaults,
  examFormTests: [
    {
      __typename: "ExamFormTestProm",
      ...createProm("en"), // Default to English
    },
  ],
};

export const getNeckDisabilityIndexProm = (locale: string = "en") => {
  return {
    ...defaults,
    examFormTests: [
      {
        __typename: "ExamFormTestProm",
        ...createProm(locale),
      },
    ],
  };
};

export const neckDisabilityIndexCalculations = (questions: Question[]) => {
  const sum = questions.reduce((reducer, question) => {
    const score = question.userAnswer ?? 0;

    return score + reducer;
  }, 0);

  return (sum / 50) * 100;
};
